import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex" }

import { ref } from 'vue';
import useBaseValidation from '@/hooks/validation/useBaseValidation';
import countries from '@/constants/dataContries';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputPhone',
  props: {
    phone: {},
    code: { default: '+7' },
    error: { type: [Array, Boolean] },
    errorMessage: {},
    dense: { type: Boolean, default: false }
  },
  emits: [
  'update:phone',
  'update:code',
  'keydown',
],
  setup(__props: any, { emit: emits }) {

const props = __props;

const { required } = useBaseValidation();





const findCountry = (code: string) => countries.find((i) => i.code === code);

const country = ref(findCountry(props.code ? props.code : '+7'));


return (_ctx: any,_cache: any) => {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_select, {
      "model-value": country.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((country).value = $event)),
        _cache[1] || (_cache[1] = (newCountry) => {
        emits('update:code', newCountry?.code)
        emits('update:phone', null);
        _ctx.$refs.phone.$el.focus();
      })
      ],
      dense: _ctx.dense,
      "option-value": "code",
      "option-label": "code",
      label: _ctx.$t('registry.code'),
      style: {"width":"60px"},
      "popup-content-style": `width: 450px; word-break: break-word;`,
      options: _unref(countries)
    }, {
      option: _withCtx(({ itemProps, opt }) => [
        _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(itemProps)), {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { style: {"flex":"50px"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "flag",
                  style: _normalizeStyle(`background: url(/img/flags.png) 0 0;
              background-position: 0 -${(opt?.index * (24 + 10))}px`)
                }, null, 4)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_label, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(opt?.name) + " (" + _toDisplayString(opt?.code) + ")", 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1040)
      ]),
      _: 1
    }, 8, ["model-value", "dense", "label", "options"]),
    _createVNode(_component_q_input, {
      ref: "phone",
      dense: _ctx.dense,
      type: "tel",
      style: {"flex":"auto"},
      "model-value": _ctx.phone,
      label: _ctx.$t('registry.phone'),
      placeholder: _ctx.$t('registry.enterPhone'),
      rules: [_unref(required)],
      mask: country.value.mask,
      error: props.error,
      "error-message": props.errorMessage,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = (e) => emits('update:phone', e)),
      onKeydown: _cache[3] || (_cache[3] = ($event: any) => (emits('keydown')))
    }, null, 8, ["dense", "model-value", "label", "placeholder", "rules", "mask", "error", "error-message"])
  ]))
}
}

})